import { render, staticRenderFns } from "./termsModel.vue?vue&type=template&id=629adbac&scoped=true"
import script from "./termsModel.vue?vue&type=script&lang=js"
export * from "./termsModel.vue?vue&type=script&lang=js"
import style0 from "./termsModel.vue?vue&type=style&index=0&id=629adbac&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "629adbac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('629adbac')) {
      api.createRecord('629adbac', component.options)
    } else {
      api.reload('629adbac', component.options)
    }
    module.hot.accept("./termsModel.vue?vue&type=template&id=629adbac&scoped=true", function () {
      api.rerender('629adbac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/insurance/insuranceManage/components/termsModel.vue"
export default component.exports